var _path, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConestoga(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 14,
    viewBox: "0 0 25 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.425 10.5H1V8.28947H1.825M19.425 10.5V9.11842L18.325 8.28947H16.675M19.425 10.5H23.275L24.1 9.11842V5.80263M1.825 8.28947H4.025M1.825 8.28947V1.65789M1.825 0.828947V1.65789M4.025 8.28947V0.828947M4.025 8.28947H6.5M6.5 8.28947V0.828947M6.5 8.28947H8.975M8.975 8.28947V0.828947M8.975 8.28947H11.175M11.175 8.28947V0.828947M11.175 8.28947H13.375M13.375 8.28947V1.65789M13.375 8.28947H16.675M13.375 0.828947V1.65789M1.825 1.65789H13.375M16.675 0V1.65789M16.675 8.28947V1.65789M16.675 1.65789H19.975M19.975 1.65789L24.1 5.80263M19.975 1.65789V5.80263H24.1",
    stroke: "#626262",
    strokeWidth: 0.8
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.85002,
    cy: 11.55,
    r: 2.05,
    stroke: "#626262",
    strokeWidth: 0.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.45,
    cy: 11.55,
    r: 2.05,
    stroke: "#626262",
    strokeWidth: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConestoga);
export default __webpack_public_path__ + "static/media/conestoga.223c49b6213d51acd9176c1a448923e3.svg";
export { ForwardRef as ReactComponent };